import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import { useSEO } from '../../utils/seo';

export default function AboutPage() {
  useSEO({
    title: '事業概要 | 赤帽みなとサービス - 長崎県の軽運送サービス',
    description: '長崎県を拠点とする軽運送事業「赤帽みなとサービス」の事業概要。20年以上の実績で、引越し、家具運搬、不用品整理、貨物配送など幅広いサービスを提供。赤帽加盟店として安心・信頼のサービスをお届けします。',
    keywords: '長崎,軽運送,事業概要,会社概要,赤帽,赤帽みなとサービス,引越し,貨物配送',
    canonical: '/about',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '事業概要',
      description: '赤帽みなとサービスの事業概要ページ',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
      mainEntity: {
        '@type': 'LocalBusiness',
        name: '赤帽みなとサービス',
        description: '長崎県を拠点とした軽運送事業者。引越し、家具・家電運搬、不用品整理、貨物配送など幅広いサービスを提供。',
        telephone: '0120-743-643',
        address: {
          '@type': 'PostalAddress',
          addressRegion: '長崎県',
          addressCountry: 'JP'
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: '32.744839',
          longitude: '129.873756'
        },
        openingHoursSpecification: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '00:00',
          closes: '23:59'
        },
        areaServed: {
          '@type': 'Place',
          name: '長崎県'
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Company Info */}
      <section className="py-12 md:py-20 bg-white pt-24 md:pt-32">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-8 md:mb-12 text-center">
            事業情報
          </h2>
          <div className="bg-[#ede9e3] rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-8 lg:p-12">
            <table className="w-full">
              <tbody className="divide-y divide-gray-300">
                <tr className="flex flex-col sm:table-row">
                  <th className="py-2 sm:py-4 pr-4 text-left text-xs sm:text-sm font-bold text-gray-900 sm:w-1/3 align-top">屋号</th>
                  <td className="pb-4 sm:py-4 text-xs sm:text-sm text-gray-700">赤帽みなとサービス</td>
                </tr>
                <tr className="flex flex-col sm:table-row">
                  <th className="py-2 sm:py-4 pr-4 text-left text-xs sm:text-sm font-bold text-gray-900 align-top">所在地</th>
                  <td className="pb-4 sm:py-4 text-xs sm:text-sm text-gray-700">長崎県</td>
                </tr>
                <tr className="flex flex-col sm:table-row">
                  <th className="py-2 sm:py-4 pr-4 text-left text-xs sm:text-sm font-bold text-gray-900 align-top">電話番号</th>
                  <td className="pb-4 sm:py-4 text-xs sm:text-sm text-gray-700">
                    <a href="tel:0120-743-643" className="hover:text-[#ebe960] transition-colors">
                      0120-743-643(フリーダイヤル)
                    </a>
                  </td>
                </tr>
                <tr className="flex flex-col sm:table-row">
                  <th className="py-2 sm:py-4 pr-4 text-left text-xs sm:text-sm font-bold text-gray-900 align-top">営業時間</th>
                  <td className="pb-4 sm:py-4 text-xs sm:text-sm text-gray-700">24時間365日対応</td>
                </tr>
                <tr className="flex flex-col sm:table-row">
                  <th className="py-2 sm:py-4 pr-4 text-left text-xs sm:text-sm font-bold text-gray-900 align-top">事業内容</th>
                  <td className="pb-4 sm:py-4 text-xs sm:text-sm text-gray-700">
                    軽貨物運送事業<br />
                    ・引越しサービス<br />
                    ・家具・家電運搬<br />
                    ・不用品整理<br />
                    ・貨物配送(定期便・スポット便)
                  </td>
                </tr>
                <tr className="flex flex-col sm:table-row">
                  <th className="py-2 sm:py-4 pr-4 text-left text-xs sm:text-sm font-bold text-gray-900 align-top">加盟団体</th>
                  <td className="pb-4 sm:py-4 text-xs sm:text-sm text-gray-700">赤帽(全国赤帽軽自動車運送協同組合連合会)</td>
                </tr>
                <tr className="flex flex-col sm:table-row">
                  <th className="py-2 sm:py-4 pr-4 text-left text-xs sm:text-sm font-bold text-gray-900 align-top">保険</th>
                  <td className="pb-4 sm:py-4 text-xs sm:text-sm text-gray-700">貨物保険加入済み</td>
                </tr>
              </tbody>
            </table>

            {/* Google Map */}
            <div className="mt-6 md:mt-8 rounded-xl md:rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.5!2d129.7892!3d32.8847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3541598c8b8b8b8b%3A0x1234567890abcdef!2z6ZW35bSO55yM6ZW35bSO5biC55C05rW35oi45qC555S6MjM4LTM2!5e0!3m2!1sja!2sjp!4v1700000000000"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="長崎県長崎市琴海戸根町238-36の地図"
                className="md:h-[400px]"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 md:py-20 bg-[#ede9e3]">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            お気軽にご相談ください
          </h2>
          <p className="text-sm md:text-lg text-gray-600 mb-6 md:mb-10">
            お見積もり・ご相談は無料です
          </p>

          <div className="flex justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 md:gap-3 bg-gray-900 text-white px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-full text-base sm:text-lg md:text-xl font-bold hover:bg-gray-800 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-fill text-lg sm:text-xl md:text-2xl"></i>
              お問い合わせはこちら
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <LineFloatingButton />
    </div>
  );
}
